//  Angular imports
import { Component, inject } from '@angular/core';
//  Application imports
import { UserService } from 'app/services/user.service';
import { NgIf } from '@angular/common';
import { BannerComponent } from '../banner/banner.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'zf-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NgIf, BannerComponent, RouterOutlet]
})
export class AppComponent {
    userService = inject(UserService);

    public readonly currentYear: number = new Date().getFullYear();
}
